module.exports = __webpack_public_path__ + "img/logo.daee1fd0.png";